/** @typedef {import("../../../api/types").Order} Order */
import React, {useState} from "react";
import axios from "axios";
import {Button} from "reactstrap";
import ConfirmModal from "../../../shared/components/ConfirmModal";
import IconLabel from "../../../shared/components/IconLabel";
import {RefreshIcon} from "../../../shared/components/icons";

const MESSAGES = {
    services: "Os serviços passam a usar os preços e custos atuais do catálogo e o total é recalculado.",
    products: "Os produtos passam a usar os preços e custos atuais do catálogo e o total é recalculado.",
};

/**
 * "Atualizar preços": prices the order's services, or its products, at the
 * catalog's current prices again, after asking (`lines` says which; each has
 * the button in its own card). Whether it is offered is up to the API
 * (`available_actions`), so the caller only renders it then.
 * @param {{order: Order, lines: "services"|"products", onUpdated: (order: Order) => void}} props
 */
const RefreshPricesButton = ({order, lines, onUpdated}) => {
    const [asking, setAsking] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(/** @type {string|null} */ (null));
    const url = `/os/api/service_orders/${order.id}/`;

    const run = async () => {
        setBusy(true);
        setError(null);
        try {
            const {data} = await axios.post(`${url}refresh_prices/`, {lines});
            onUpdated(data);
        } catch (err) {
            if (err.response?.status === 409) {
                setError("O status da ordem mudou e os preços não podem mais ser atualizados.");
                try {
                    // Show what the order looks like now.
                    onUpdated((await axios.get(url)).data);
                } catch {
                    // Keep the stale view; the message above still applies.
                }
            } else {
                setError("Não foi possível atualizar os preços. Tente novamente.");
            }
        } finally {
            setBusy(false);
            setAsking(false);
        }
    };

    return (
        <>
            {error && <span className="text-danger small me-2">{error}</span>}
            <Button color="primary" outline size="sm" onClick={() => setAsking(true)}>
                <IconLabel icon={<RefreshIcon />}>Atualizar preços</IconLabel>
            </Button>
            {asking && (
                <ConfirmModal
                    isOpen
                    title="Tem certeza?"
                    message={MESSAGES[lines]}
                    confirmLabel="Atualizar preços"
                    confirmIcon={RefreshIcon}
                    busy={busy}
                    onConfirm={run}
                    onCancel={() => setAsking(false)}
                />
            )}
        </>
    );
};

export default RefreshPricesButton;
